import { pointerWithin, rectIntersection, type CollisionDetection } from '@dnd-kit/core';

/**
 * Pointer drags land only on a target the pointer is inside. Releasing over empty space, the
 * canvas, or a footer does not snap the row to whichever target happens to be nearest.
 * Keyboard drags have no pointer, so the moved row's rectangle is used the same way: a pickup
 * starts over its own slot, and a drag whose rectangle misses every row moves nothing.
 */
export const pointerOrKeyboardCollision: CollisionDetection = (args) =>
  args.pointerCoordinates ? pointerWithin(args) : rectIntersection(args);
